export const RISK_IDENTITY_VERSION = 1;
export const RISK_STABLE_ID_COOKIE_NAME = 'bg_rid';
export const RISK_STABLE_ID_HEADER_NAME = 'x-risk-stable-id';
